export type NotificationType = "info" | "success" | "warning" | "error" | "unknown";
export class NotificationConstants {
    public static animationTime: number = 350;
}
